import { useState, useRef, useEffect } from 'react';

/**
 * ComboboxSelect — usar siempre con Controller de React Hook Form.
 * Nunca con register(). Nunca usar <select> nativo para opciones de la API.
 */
export function ComboboxSelect({ options = [], value, onChange, placeholder = 'Seleccionar...' }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Cierra el dropdown al hacer click fuera
  useEffect(() => {
    if (!open) return;
    function handler(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setQuery('');
      }
    }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const filtered = options.filter((o) =>
    o.label.toLowerCase().includes(query.toLowerCase())
  );

  const selected = options.find((o) => o.value === value);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full text-left border border-gray-200 rounded-md px-3 py-2 text-sm font-['Inter'] bg-white focus:outline-none focus:ring-2 focus:ring-[#0D2B5C]"
      >
        {selected?.label ?? <span className="text-gray-400">{placeholder}</span>}
      </button>

      {open && (
        <div className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg">
          <div className="p-2">
            <input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Buscar..."
              className="w-full border border-gray-200 rounded px-2 py-1.5 text-sm font-['Inter'] focus:outline-none"
            />
          </div>
          <ul className="max-h-48 overflow-y-auto">
            {filtered.map((o) => (
              <li
                key={o.value}
                onClick={() => { onChange(o.value); setOpen(false); setQuery(''); }}
                className="px-3 py-2 text-sm font-['Inter'] hover:bg-gray-50 cursor-pointer"
              >
                {o.label}
              </li>
            ))}
            {!filtered.length && (
              <li className="px-3 py-2 text-sm text-gray-400 font-['Inter']">Sin resultados</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
